import styled from 'styled-components';

export const TagWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 33px;
  height: 16px;
  padding: 0 6px;
  border-radius: 4px;
  background-color: #00a889;
  color: #ffffff !important;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
`;
